import React from "react";

function Section ({ title, subtitle, id, comp, img }) {
    return(
        <div className="section" id={id}>
          <h1>{title}</h1>
          {img && <img src={img} alt="profile" className="profile-image" />}
          {/* <img src={img} alt="profile" class="profile-image"/> */}
          <p>{subtitle}</p>
          {comp}
        </div>
    )
};

export default Section;